import { useQuery } from '@tanstack/react-query';
import { AnswerRepositoryImpl } from '../../data/repository/answer_repository';
import { AxiosError } from 'axios';
import { AnswerInterface } from '../interface/answer_interface';

export const useGetUserStartAnswers = (themeId?: string) => {
  const repository = new AnswerRepositoryImpl();

  return useQuery<AnswerInterface[], AxiosError>({
    queryKey: ['useGetUserStartAnswers', themeId],
    queryFn: () => repository.getUserAnswersByThemeId(themeId!, 'start'),
    enabled: !!themeId,
  });
};

export const useGetUserEndAnswers = (themeId?: string) => {
  const repository = new AnswerRepositoryImpl();

  return useQuery<AnswerInterface[], AxiosError>({
    queryKey: ['useGetUserEndAnswers', themeId],
    queryFn: () => repository.getUserAnswersByThemeId(themeId!, 'end'),
    enabled: !!themeId,
  });
};
